import React, { FC, useEffect, useState } from 'react';
import { useAuth } from '../auth/authContext';
import { useAnayzeService } from '../services/useAnalyzeService';
import { JobPostingDto } from '../types/jobPostingDto';
import { AnalysisResult } from '../types/analysisResult';
import './pastJobPostingsanalysis.css';
import { JobPostingAnalysisDto } from '../types/jobPostingAnalysisDto';
import { AnalysisAIResultPanel } from './analysisAIResults';
import { AnalysisSuggestionsPanel } from './analysisSuggestions';

const PastJobPostingsAnalysis: FC = () => {
    const { user } = useAuth();
    const { getPastJobPostingsAnalysis, getPastJobAnalysisByJobPostingId } = useAnayzeService();
    const [jobPostingData, setJobPostingData] = useState<JobPostingDto[]>([]);
    const [jobAnalysisData, setJobAnalysisData] = useState<JobPostingAnalysisDto | null>(null);
    const [selectedJob, setSelectedJob] = useState<JobPostingDto | null>(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [, setSelectedAnalysis] = useState<AnalysisResult | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchJobPostings = async () => {
            try {
                setLoading(true);
                const data = await getPastJobPostingsAnalysis(user!.id);
                setJobPostingData(data);
                console.log('Fetched past job postings:', data);
            } catch (err) {
                setError('Failed to load past job postings.');
            } finally {
                setLoading(false);
            }
        };
        fetchJobPostings();
    }, [getPastJobPostingsAnalysis, user]);

    const handleJobSelect = async (job: JobPostingDto) => {
        setSelectedJob(job);
        setShowSuggestions(false);
        try {
            const data = await getPastJobAnalysisByJobPostingId(job.jobPostingId);
            setJobAnalysisData(data);
            console.log('Fetched job analysis data:', data?.analysisResponse);
        } catch (err) {
            console.error('Error creating analysis result:', err);
            setSelectedAnalysis(null);
        }
    };



    const handleSuggestionSelect = async () => {
        if (!showSuggestions)
            setShowSuggestions(true);
        else
            setShowSuggestions(false);
    };

    return (
        <div className="job-postings-analysis">
            {error && <p style={{color: 'red'}}>{error}</p>}
            {loading && <p>Loading past job postings...</p>}
            <div className="left-panel">
                <h2>Past Job Postings</h2>
                <div className="job-list">
                    {jobPostingData.map((job, index) => (
                        <div
                            key={index}
                            className={`job-item ${selectedJob === job ? 'selected' : ''}`}
                            onClick={() => handleJobSelect(job)}
                        >
                            <h3>{job.company || 'Unknown Company'}</h3>
                            <p>{job.title || 'Unknown Title'}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="right-panel">
                {jobAnalysisData ? (
                    <div className="job-details">
                        <div className="job-info">
                            <h2>{jobAnalysisData.company}</h2>
                            <h3>{jobAnalysisData.title || 'Unknown Title'}</h3>
                            <p><strong>Posted Date:</strong> {new Date(jobAnalysisData.postedDateUtc).toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}) || 'Not specified'}</p>

                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
                                <div className="raw-text">
                                    <h4>Job Description</h4> 
                                    <div>
                                        <div style={{display: 'flex', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', maxHeight: '200px', overflowY: 'auto'}}>
                                            {jobAnalysisData.jobDescription}
                                        </div>
                                    </div>
                                </div>
                                <div className="raw-text">
                                    <h4>Resume Text</h4>
                                    <div>
                                        <div style={{display: 'flex', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', maxHeight: '200px', overflowY: 'auto'}}>
                                            {jobAnalysisData.resumeText}
                                        </div>
                                    </div>
                                </div>
                                <div><button className='btn btn-link' onClick={() => handleSuggestionSelect()} >Improvement Suggestions</button></div>
                            </div>
                        </div>
                        {jobAnalysisData.nextImprovementResponse && showSuggestions && <AnalysisSuggestionsPanel results={jobAnalysisData.nextImprovementResponse} />}
                        {jobAnalysisData.analysisResponse && <AnalysisAIResultPanel result={jobAnalysisData.analysisResponse} />}
                    </div>
                ) : (
                    <div className="no-selection">
                        Select a job posting to view details and analysis.
                    </div>
                )}
            </div>
        </div>
    );    
};

export default PastJobPostingsAnalysis;